import { render, staticRenderFns } from "./PartnerSupport.vue?vue&type=template&id=2164f92c&scoped=true"
import script from "./PartnerSupport.vue?vue&type=script&lang=ts"
export * from "./PartnerSupport.vue?vue&type=script&lang=ts"
import style0 from "./PartnerSupport.vue?vue&type=style&index=0&id=2164f92c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2164f92c",
  null
  
)

export default component.exports